import { Col, Row } from "antd";
import { EDIT_TRADE_DETAILS_LABELS } from "constants/auditTrail";

import classnames from "classnames";
import { PrimaryButton } from "components/Common/CustomButtons/CustomButtons";

function BuyOrSellButtons({
  isSellActive,
  setIsSellActive,
  setIsTradeRequestFire,
  isLoading,
}) {
  return (
    <Col span={24} style={{ marginBottom: "10px" }}>
      <Row>
        <Col span={12}>
          <PrimaryButton
            disabled={isLoading}
            style={{
              width: "100%",
              backgroundColor:
                isSellActive !== null && !isSellActive
                  ? "var(--color-blue-3)"
                  : "transparent",
              color:
                isSellActive !== null && !isSellActive
                  ? "var(--color-white-1)"
                  : "var(--color-blue-3)",
            }}
            onClick={() => {
              setIsSellActive(false);
              setIsTradeRequestFire((prev) =>
                prev === null ? true : prev === true ? prev : !prev
              );
            }}
            className={classnames({
              "active-button": isSellActive !== null && !isSellActive,
            })}
            key={EDIT_TRADE_DETAILS_LABELS.BUY}
          >
            {EDIT_TRADE_DETAILS_LABELS.BUY}
          </PrimaryButton>
        </Col>
        <Col span={12}>
          <PrimaryButton
            disabled={isLoading}
            style={{
              width: "100%",
              backgroundColor:
                isSellActive !== null && isSellActive
                  ? "var(--color-blue-3)"
                  : "transparent",
              color:
                isSellActive !== null && isSellActive
                  ? "var(--color-white-1)"
                  : "var(--color-blue-3)",
            }}
            onClick={() => {
              setIsSellActive(true);
              setIsTradeRequestFire((prev) =>
                prev === null ? true : prev === true ? prev : !prev
              );
            }}
            className={classnames({
              "active-button": isSellActive !== null && isSellActive,
            })}
            key={EDIT_TRADE_DETAILS_LABELS.SELL}
          >
            {EDIT_TRADE_DETAILS_LABELS.SELL}
          </PrimaryButton>
        </Col>
      </Row>
    </Col>
  );
}

export default BuyOrSellButtons;
